import { useCallback, useState } from 'react'

export const useStateFilter = () => {
  const [filteredStates, setFilteredStates] = useState<string[]>([])

  const handleStateFilterChange = useCallback((state: string, checked: boolean) => {
    setFilteredStates(prev =>
      checked ? [...prev, state] : prev.filter(s => s !== state)
    )
  }, [])

  const toggleState = useCallback((state: string) => {
    setFilteredStates(prev => {
      if (prev.includes(state)) {
        return prev.filter(s => s !== state)
      } else {
        return [...prev, state]
      }
    })
  }, [])

  const setStates = useCallback((states: string[]) => {
    setFilteredStates(states)
  }, [])

  const clearStates = useCallback(() => {
    setFilteredStates([])
  }, [])

  return {
    filteredStates,
    setFilteredStates,
    handleStateFilterChange,
    toggleState,
    setStates,
    clearStates
  }
}
